// Prop Firm Logo mappings
export const PROP_FIRM_LOGOS = {
  'Lucid Trading': '/logos/lucid.png',
  'Lucid': '/logos/lucid.png',
  'MFF': '/logos/mff.png',
  'MyForexFunds': '/logos/mff.png',
  'My Forex Funds': '/logos/mff.png',
  'Tradeify': '/logos/tradeify.png',
  // CFD Prop Firms
  'Prop Number 1': '/icons/prop-number-1.png',
  'Prop Number One': '/icons/prop-number-1.png',
  'PropNumber1': '/icons/prop-number-1.png',
  'PN1': '/icons/prop-number-1.png',
};

export const getPropFirmLogo = (firmName) => {
  if (!firmName) return null;
  
  // Exact match
  if (PROP_FIRM_LOGOS[firmName]) {
    return PROP_FIRM_LOGOS[firmName];
  }
  
  // Case-insensitive match
  const lowerName = firmName.toLowerCase();
  for (const [key, value] of Object.entries(PROP_FIRM_LOGOS)) {
    if (key.toLowerCase() === lowerName || lowerName.includes(key.toLowerCase())) {
      return value;
    }
  }
  
  return null;
};

export const PropFirmLogo = ({ firmName, size = 24, className = '' }) => {
  const logo = getPropFirmLogo(firmName);
  
  if (!logo) {
    return null;
  }
  
  return (
    <img 
      src={logo} 
      alt={firmName}
      className={`rounded object-contain ${className}`}
      style={{ width: size, height: size }}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  );
};
